<template>
  <v-container fluid fill-height class="page-not-found">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 lg4>
        <v-card>
          <v-card-text>
            <div class="subheading text-xs-center">Page not found</div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'page-not-found'
}
</script>

<style lang="scss">
  .page-not-found {
  }
</style>
